export const LogoMark = ({ className = "h-9 w-9", dark = true }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="16" fill={dark ? "#0D0F12" : "#FAFAF7"} />
    <g fill="none" stroke="#D4B06A" strokeWidth="5" strokeLinecap="round">
      <circle cx="22" cy="25" r="8" />
      <path d="M30 25v9c0 9-5 14-13 14" />
      <circle cx="43" cy="25" r="8" />
      <path d="M51 25v9c0 9-5 14-13 14" />
    </g>
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark dark={!light} />
    <span className="leading-none">
      <span className={`block font-display text-lg font-extrabold tracking-tight ${light ? "text-pearl" : "text-ink"}`}>CARS 99</span>
      <span className={`block font-mono text-[10px] uppercase tracking-[0.28em] ${light ? "text-zinc-400" : "text-slate-500"}`}>Udine · Europa</span>
    </span>
  </span>
);
